import { LAW_HTML } from '@/utils/constants/static/tpl/law';
import { PRIVACY_HTML } from '@/utils/constants/static/tpl/privacy';
import { TERMS_HTML } from '@/utils/constants/static/tpl/terms';
import { TERMS_PS_HTML } from '@/utils/constants/static/tpl/termsPs';
export const STATIC_PAGE_CONTENT = {
    law: LAW_HTML,
    privacy: PRIVACY_HTML,
    terms: TERMS_HTML,
    termsPs: TERMS_PS_HTML,
};
